import { render, staticRenderFns } from "./PersistRastreamentoView.vue?vue&type=template&id=6a1c9f14&"
import script from "./PersistRastreamentoView.vue?vue&type=script&lang=ts&"
export * from "./PersistRastreamentoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports